import React, { useMemo, useState } from "react";
import Deposit from "./Deposit.js";
import Redeem from "./Redeem.js";
import Distribute from "./Distribute.js";
import Approve from "./Approve.js";
import logo from "../images/logo.png";
import Footer from "./Footer.js";
const Navbar = () => {
  const [activeComponent, setActiveComponent] = useState("Deposit");

  const [account, setAccount] = useState(null);

  const renderComponent = () => {
    switch (activeComponent) {
      case "Deposit":
        return <Deposit />;
      case "Redeem":
        return <Redeem />;
      case "Distribute":
        return <Distribute />;
      case "Approve":
        return <Approve />;
      default:
        return null;
    }
  };

  const tronWeb=useMemo(() => {
    return window.tronWeb
  },[])

  const connectToTronLink = async () => {
    try {
      // Check if TronLink is installed
      if (window.tron && window.tronWeb) {

        const currentAccount = await tronWeb.trx.getAccount();
        console.log(currentAccount);

        // Get current address from TronLink
        const address = window.tronWeb.defaultAddress.base58;
        setAccount(currentAccount);
   

        console.log("Connected to TronLink:", address);
        // Update state with the current address
        sessionStorage.setItem("currentAddress", address.toString());
      } else {
        // TronLink is not installed or not available
        console.error("TronLink not found. Please install TronLink extension.");
      }
    } catch (error) {
      console.error("Error connecting to TronLink:", error);
    }
  };
  return (
    <div className=" bg-[#fffaf4] min-w-screen font-main">
      <header className="w-full mt-5 text-gray-700   shadow-md  body-font">
        <div className="container flex flex-col items-start justify-between p-10 mx-auto md:flex-row">
          <h6 className="font-bold ml-2  text-lg">Rastro</h6>
          <img
            alt="logo"
            height={30}
            width={30}
            src={logo}
            className="flex  items-center "
          />
          <nav className="flex flex-wrap items-center justify-center pl-4 text-base md:ml-auto md:mr-auto">
            <button
              className="mr-5 font-medium hover:text-gray-900"
              onClick={() => setActiveComponent("Deposit")}
            >
              Deposit
            </button>
            <button
              className="mr-5 font-medium hover:text-gray-900"
              onClick={() => setActiveComponent("Redeem")}
            >
              Redeem
            </button>
            <button
              className=" mr-5 font-medium hover:text-gray-900"
              onClick={() => setActiveComponent("Distribute")}
            >
              Distribute
            </button>

            <button
              className="font-medium hover:text-gray-900"
              onClick={() => setActiveComponent("Approve")}
            >
              Approve
            </button>
          </nav>
          <div className="flex items-center space-x-4  justify-between ">
            <p className=" font-medium hover:text-gray-900">
              {/* {sessionStorage.getItem("currentAddress").slice(0, 4)}...
              {sessionStorage.getItem("currentAddress").slice(-6)} */}
            </p>
            <button
              onClick={connectToTronLink}
              className="px-4 py-2 text-xs font-bold text-white uppercase transition-all duration-150 bg-[#2c749d] rounded shadow outline-none active:bg-teal-600 hover:shadow-md focus:outline-none ease"
            >
              {account
                ? "Connect Wallet"
                : "Connected"}{" "}
            </button>
          </div>
        </div>
      </header>
      {renderComponent()}
      <Footer />
    </div>
  );
};

export default Navbar;
